import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors/";

export default makeStyles((theme) => ({
  root: {},
  listItem: {
    height: "auto",
    borderRadius: theme.spacing(0.5),
    "&:hover": {
      backgroundColor: grey[50],
    },
  },
  addButton: {
    color: theme.palette.primary.main,
  },
  listItemSelected: {
    background: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    opacity: "1 !important",
  },
  listItemText: {
    fontSize: 14,
    lineHeight: 1.4,
    fontWeight: 600,
  },
}));
